// @flow

import React from "react";

import EditableForm from "../../components/EditableForm";
import FormRow from "../../components/FormRow";
import EditableField from "../../components/EditableField";
import * as mappers from "../../utils/mappers";
import * as v from "../../utils/validators";
import * as formatters from "../../utils/formatters";
import { errors } from "../../utils/errors";
import { placeholders } from "../../utils/placeholders";

import {
  PURPOSE_KIND,
  GOODS_PURCHASE_PRICE,
  FEDERAL_STATE,
  GOODS_DESCRIPTION,
  GOODS_SUPPLIER,
  GOODS_ESTIMATED_DELIVERY_DATE
} from "./formFields";
import { mapPurposeKind, getKind } from "./mappers";

import { type InvestmentSectionProps } from "../../types/details";

const InvestmentGoods = ({
  kind,
  initialValues,
  handleSubmit,
  isLocked
}: InvestmentSectionProps) => {
  return (
    <EditableForm initialValues={initialValues} onSubmit={handleSubmit} isLocked={isLocked}>
      <FormRow separator>
        <EditableField
          fieldControlProps={{
            name: PURPOSE_KIND,
            caption: () => "Investitionsvorhaben"
          }}
          displayValue={value => {
            const purposeKind = getKind(value, kind);
            return purposeKind && mapPurposeKind(purposeKind.kind);
          }}
        />
        <EditableField
          fieldControlProps={{
            name: GOODS_PURCHASE_PRICE,
            caption: () => "Kaufpreis (Netto)"
          }}
          displayValue={formatters.formatCurrency}
        />
        <EditableField
          fieldControlProps={{
            name: FEDERAL_STATE,
            caption: () => "Investitionsort liegt in..."
          }}
        />
      </FormRow>
      <FormRow separator>
        <EditableField
          fieldControlProps={{
            name: GOODS_DESCRIPTION,
            caption: () => "Beschreibung"
          }}
        />
        <div />
      </FormRow>
      <FormRow>
        <EditableField
          fieldControlProps={{
            name: GOODS_SUPPLIER,
            caption: () => "Lieferant",
            validate: v.combineWithPrefillCheck(
              errors.requiredField(),
              v.maxLength(100, errors.maxLengthCharacters(100))
            )
          }}
          type="textInput"
          inputProps={{ placeholder: "z.B. Würth AG" }}
        />
        <EditableField
          fieldControlProps={{
            name: GOODS_ESTIMATED_DELIVERY_DATE,
            caption: () => "Voraussichtliches Lieferdatum",
            validate: v.combineWithPrefillCheck(errors.requiredField())
          }}
          type="datePicker"
          inputProps={{
            datePickerFormFormat: "yyyy-MM-dd",
            placeholder: placeholders.pleaseSelect
          }}
          displayValue={mappers.dateMapper}
        />
        <div />
      </FormRow>
    </EditableForm>
  );
};

export default InvestmentGoods;
